import { render, staticRenderFns } from "./DoublesCard.vue?vue&type=template&id=4a7cd005&scoped=true&"
import script from "./DoublesCard.vue?vue&type=script&lang=js&"
export * from "./DoublesCard.vue?vue&type=script&lang=js&"
import style0 from "./DoublesCard.vue?vue&type=style&index=0&id=4a7cd005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7cd005",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VFlex,VImg,VLayout})
